$('.tablinkaction').on('click', function () {
    const section = $(this).data('section')
    const tab = $(this).data('tab')

    if (!$(this).hasClass('active')) {
        $(this).parent().find('.tablinkaction').removeClass('active');
        $(`.tab-${section}`).removeClass('active')

        $(this).addClass('active')
        $(`#tab-${section}-${tab}`).addClass('active')
    }
})
